import { render, staticRenderFns } from "./TeamsIcon.vue?vue&type=template&id=45b14032"
import script from "./TeamsIcon.vue?vue&type=script&lang=js"
export * from "./TeamsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports